import { useRef, useState } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";

export default function Contact() {
  const form = useRef();
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please verify that you are not a robot.");
      return;
    }

    setIsSending(true);

    emailjs
      .sendForm(
        "service_8beg4cw",     // service ID from EmailJS dashboard
        "template_t1jjxyk",    // template ID from EmailJS dashboard
        form.current,
        "0KwmijEkeegbFT_uV"         // public key from EmailJS
      )
      .then(
        () => {
          alert("Message sent successfully!");
          setIsSending(false);
          form.current.reset();
          setCaptchaValue(null);
        },
        (error) => {
          alert("Something went wrong: " + error.text);
          setIsSending(false);
        }
      );
  };


  return (
    <section id="contact" className="py-16 bg-gray-50" data-aos="fade-up">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left: Company Info */}
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900">Contact Drive Dobias</h2>
            <p className="text-sm text-gray-600 max-w-md">
              We’d love to hear from you. Reach out with any questions about our rental service.
            </p>
            {/* ... address/phone info ... */}
          </div>

          {/* Right: Contact Form */}
          <form ref={form} onSubmit={sendEmail} className="space-y-6 bg-white p-6 rounded-lg shadow">
            <div>
              <label className="block text-sm font-medium text-gray-700">Full Name</label>
              <input type="text" name="user_name" required className="mt-1 block w-full border border-gray-300 bg-gray-50 rounded-md px-4 py-3 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Email Address</label>
              <input type="email" name="user_email" required className="mt-1 block w-full border border-gray-300 bg-gray-50 rounded-md px-4 py-3 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Phone Number</label>
              <input type="tel" name="user_phone" className="mt-1 block w-full border border-gray-300 bg-gray-50 rounded-md px-4 py-3 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Message</label>
              <textarea name="message" rows="4" required className="mt-1 block w-full border border-gray-300 bg-gray-50 rounded-md px-4 py-3 shadow-sm focus:border-blue-500 focus:ring-blue-500"></textarea>
            </div>

            {/* reCAPTCHA */}
            <ReCAPTCHA
              sitekey="6Lcq2N8rAAAAAKXVqX9WRMJzsAFRYwrOExvmT9hI"
              onChange={(value) => setCaptchaValue(value)}
            />

            <button
              type="submit"
              disabled={isSending}
              className={`w-full px-6 py-3 rounded-md transition duration-300 ${
                isSending
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 text-white hover:bg-blue-700"
              }`}
            >
              {isSending ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}